module.exports = __webpack_public_path__ + "img/vpi-2.516ca97a.svg";